/* Funnel page 3.1.0: what waits for the parsed page (deferred, on every page): the discount-code notice, the
   store's payment marks, Cookie preferences, in-page links that keep #… out of the address, the page's signup and
   contact forms posted to Shopify without a reload, a fix offered for a mistyped email address, the signup popup,
   and a header that steps aside while scrolling down. Sends no analytics: a form dispatches `funnel:submit` (cancelable) before it posts, then `funnel:signup` or
   `funnel:contact` ({detail: {state: 'ok' | 'known' | 'error', form}}) for the page's own tracking.
   A form's states in the page's markup: [data-f-ok] [data-f-known] [data-f-error] (start hidden), [data-f-fields]. */
(function () {
  'use strict';
  var d = document, w = window;
  if (w.__funnelPage) return;
  w.__funnelPage = 1;
  var F = w.Funnel || { config: {} }, C = F.config || {};
  var q = new URLSearchParams(location.search);
  var SEL = 'form[data-f-signup],form[data-f-contact]';

  // a code from the store's own emails (Funnel.discount): the page's notice shows it
  if (F.discount) {
    [].forEach.call(d.querySelectorAll('[data-f-discount]'), function (el) { el.hidden = false; });
    [].forEach.call(d.querySelectorAll('[data-f-discount-code]'), function (el) { el.textContent = F.discount; });
  }
  // no Apple Pay mark where the browser cannot pay with it
  var ap = false;
  try { ap = !!(w.ApplePaySession && w.ApplePaySession.canMakePayments()); } catch (e) {}
  if (!ap) [].forEach.call(d.querySelectorAll('[data-f-payment-icons] [aria-labelledby="pi-apple_pay"]'), function (el) { el.style.display = 'none'; });
  // Cookie preferences (footer) reopens Shopify's banner: withdrawing is as easy as giving (GDPR Art 7(3))
  // (no preferences on screen 1.5 s later, the banner could not load: the link's own target, the privacy policy)
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-f-cookie-prefs]'), b = w.privacyBanner;
    if (!a || !b || !b.showPreferences) return;
    e.preventDefault();
    try { b.showPreferences(); } catch (x) {}
    setTimeout(function () {
      var shown = [].some.call(d.querySelectorAll('[id^="shopify-pc__"]'), function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; });
      if (!shown && a.href) location.href = a.href;
    }, 1500);
  });
  // in-page links (<a href="#order">) scroll to their target without writing #… into the address: Safari and the
  // Facebook and Instagram browsers on iPhone jump back to a #… on every reload (even a pull-to-refresh at the top),
  // and Meta's pixel counts every change of the address, and the Back after it, as a PageView. The tap still adds a
  // history entry with the same address, so Back returns to where the visitor was (an Android in-app browser would
  // close on a Back with no entry), and focus moves to the target. The page's own say comes first: this acts last of
  // all click listeners (on window, added at the tap) and only when none called preventDefault(). Left to the
  // browser: data-f-plain, a tap with a modifier key, a target not on the page (qa fails the #… it then writes).
  // #top and # mean the top of the page.
  function jump(a, e) {
    if (e.defaultPrevented) return;
    var id;
    try { id = decodeURIComponent(a.href.slice(a.href.indexOf('#') + 1)); } catch (x) { return; }
    var top = !id || id.toLowerCase() === 'top';
    var el = id ? d.getElementById(id) || [].filter.call(d.getElementsByName(id), function (x) { return x.tagName === 'A'; })[0] : null;
    if (!el && !top) return;
    e.preventDefault();
    try { history.pushState(history.state, ''); } catch (x) {}
    // a closed <details> around the target opens, as on the browser's own jump
    for (var c = el, p = el && el.parentElement; p; c = p, p = p.parentElement) if (p.tagName === 'DETAILS' && !p.open && c !== p.querySelector(':scope > summary')) p.open = true;
    if (el && !el.matches('a[href],area[href],button,input,select,textarea,summary,iframe,[tabindex],[contenteditable]')) {
      // focusable only while it holds the focus, and without a ring (WebKit draws one after a focus by script, even
      // after a tap)
      var ol = el.style.outline, off = function () { el.removeAttribute('tabindex'); el.style.outline = ol; };
      el.setAttribute('tabindex', '-1');
      el.style.outline = 'none';
      el.addEventListener('blur', off, { once: true });
      try { el.focus({ preventScroll: true }); } catch (x) {}
      if (d.activeElement !== el) { el.removeEventListener('blur', off); off(); }
    } else if (el) {
      try { el.focus({ preventScroll: true }); } catch (x) {}
    } else if (d.activeElement && d.activeElement.blur) d.activeElement.blur();
    // the page's own scroll-behavior, scroll-padding and scroll-margin apply, as on the browser's own jump
    if (top) w.scrollTo({ top: 0 }); else el.scrollIntoView({ block: 'start' });
  }
  w.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || typeof a.href !== 'string' || a.hasAttribute('data-f-plain') || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    // this document only: the link's address up to its # is the page's own
    if (a.href.split('#')[0] !== location.href.split('#')[0]) return;
    w.addEventListener('click', function last(ev) {
      w.removeEventListener('click', last);
      if (ev === e) jump(a, ev);
    });
  }, true);
  // a no or a withdrawn yes: funnel.js (listening first) has opted every PostHog instance out and reset it, which
  // clears its cookie and local storage; its tab-scoped ids in session storage go here
  d.addEventListener('visitorConsentCollected', function (e) {
    if (e.detail && e.detail.analyticsAllowed) return;
    try { Object.keys(sessionStorage).forEach(function (k) { if (/^ph_phc_/.test(k)) sessionStorage.removeItem(k); }); } catch (x) {}
  });

  function each(f, sel, fn) { [].forEach.call(f.querySelectorAll(sel), fn); }
  function state(f, s) {
    var known = f.querySelector('[data-f-known]');
    each(f, '[data-f-ok]', function (e) { e.hidden = !(s === 'ok' || (s === 'known' && !known)); });
    each(f, '[data-f-known]', function (e) { e.hidden = s !== 'known'; });
    each(f, '[data-f-error]', function (e) { e.hidden = s !== 'error'; });
    each(f, '[data-f-fields]', function (e) { e.hidden = s === 'ok' || s === 'known'; });
  }
  function done(f, s) {
    f.removeAttribute('aria-busy');
    state(f, s);
    var m = f.querySelector(s === 'error' ? '[data-f-error]:not([hidden])' : '[data-f-known]:not([hidden]),[data-f-ok]:not([hidden])');
    if (m) { if (!m.hasAttribute('tabindex')) m.setAttribute('tabindex', '-1'); m.focus({ preventScroll: true }); }
    var ev;
    try { ev = new CustomEvent(f.hasAttribute('data-f-contact') ? 'funnel:contact' : 'funnel:signup', { bubbles: true, detail: { state: s, form: f } }); } catch (e) { return; }
    f.dispatchEvent(ev);
  }
  function plain(f) {
    f.removeAttribute('aria-busy');
    f.__plain = 1;
    if (f.requestSubmit) f.requestSubmit(); else HTMLFormElement.prototype.submit.call(f);
  }
  // Shopify's bot check shows its puzzle in a box on <body>, outside the form
  function puzzle(dg) {
    return [].some.call(d.querySelectorAll('iframe[src*="hcaptcha"]'), function (x) {
      return !(dg && dg.contains(x)) && x.getBoundingClientRect().height > 60 && getComputedStyle(x.parentNode).visibility !== 'hidden';
    });
  }
  // Shopify documents only Shopify.captcha.protect and the form's own submit; asking the widget for a token
  // directly is what lets the post happen in place. If that ever stops answering, the plain post (Shopify's own
  // path, a page reload) takes over: a message is never lost to it.
  function token(f) {
    return new Promise(function (ok, no) {
      // the timer covers loading the bot check only: a visitor solving its puzzle takes as long as it takes
      var cap = w.Shopify && w.Shopify.captcha, t = setTimeout(function () { no('load'); }, 10000);
      function go() {
        clearTimeout(t);
        var fr = f.querySelector('iframe[data-hcaptcha-widget-id]'), hc = w.hcaptcha;
        if (!fr) return f.getAttribute('data-hcaptcha-bound') ? no('widget') : ok(); // no bot check on this store
        if (!hc || !hc.execute) return no('api');
        var stop = reachable(f), n = 0, over = false;
        // no answer after 20 s and no puzzle on screen: the widget is stuck, take the plain way
        var wd = setInterval(function () { if (!over && ++n >= 20 && !puzzle()) { over = true; clearInterval(wd); stop(); no('stall'); } }, 1000);
        var end = function () { over = true; clearInterval(wd); stop(); };
        hc.execute(fr.getAttribute('data-hcaptcha-widget-id'), { async: true }).then(function (r) {
          if (over) return;
          end();
          var i = f.elements['h-captcha-response'];
          if (!i) { i = d.createElement('input'); i.type = 'hidden'; i.name = 'h-captcha-response'; f.appendChild(i); }
          i.value = r.response;
          ok();
        }, function (x) { if (over) return; end(); no(x); });
      }
      if (!f.getAttribute('data-hcaptcha-bound') && cap && cap.protect) cap.protect(f, go); else go();
    });
  }
  // Inside a modal dialog the puzzle would sit under the backdrop, out of reach: when it shows, the dialog
  // turns non-modal where it stands, so the puzzle is on top.
  function reachable(f) {
    var dg = f.closest('dialog');
    if (!dg || !dg.open || !w.MutationObserver || !dg.matches(':modal')) return function () {};
    var mo = new MutationObserver(function () {
      if (!puzzle(dg)) return;
      mo.disconnect();
      var r = dg.getBoundingClientRect();
      dg.close();
      dg.style.cssText += ';position:fixed;margin:0;top:' + r.top + 'px;left:' + r.left + 'px;width:' + r.width + 'px';
      dg.show();
    });
    mo.observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    return function () { mo.disconnect(); };
  }
  // a field marked data-f-tag="<prefix>" adds "<prefix>-<its value>" to the signup's tags (e.g. the state a
  // lead magnet is for); the build's own tags stay as they are
  function tagged(f) {
    var t = f.querySelector('input[name="contact[tags]"]');
    if (!t) return;
    if (t.__base == null) t.__base = t.value;
    var add = [];
    each(f, '[data-f-tag]', function (el) {
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var v = String(el.value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      if (v) add.push(el.getAttribute('data-f-tag') + '-' + v);
    });
    t.value = t.__base + (add.length ? ',' + add.join(',') : '');
  }
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches(SEL)) return;
    if (f.__plain) return;
    // a second tap while it posts: nothing (not a second funnel:submit either)
    if (f.getAttribute('aria-busy')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    // the page's own say first: a funnel:submit listener that calls preventDefault() keeps the form from posting
    var go = true;
    try { var pre = new CustomEvent('funnel:submit', { bubbles: true, cancelable: true, detail: { form: f } }); go = f.dispatchEvent(pre); } catch (x) {}
    if (!go) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    tagged(f);
    if (C.draft) {
      // the draft (page.mjs serve): ?form=known|error shows that state
      e.preventDefault(); e.stopImmediatePropagation();
      f.setAttribute('aria-busy', 'true');
      setTimeout(function () { done(f, /^(error|known)$/.test(q.get('form')) ? q.get('form') : 'ok'); }, 400);
      return;
    }
    if (C.design || !f.id || !w.fetch || !w.Promise || !w.DOMParser) return;
    // capture phase: this runs before the bot check's own listener on the form
    e.preventDefault(); e.stopImmediatePropagation();
    f.setAttribute('aria-busy', 'true');
    setTimeout(function () { f.removeAttribute('aria-busy'); }, 30000); // never a dead button: a tap retries
    var answered = false;
    token(f).then(function () {
      return fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' });
    }).then(function (r) {
      if (!r.ok || /\/challenge/.test(r.url)) throw 0; // a human check: only the plain post can show it
      answered = true; // the store took the post: never post it a second time
      if (/[?&](customer|contact)_posted=true/.test(r.url)) { try { r.body.cancel(); } catch (x) {} return done(f, 'ok'); }
      return r.text().then(function (t) {
        var back = new DOMParser().parseFromString(t, 'text/html').getElementById(f.id), vis = ':not([hidden])';
        if (!back || back.querySelector('[data-f-ok]' + vis + ',[role=status]' + vis)) return done(f, 'ok');
        done(f, back.querySelector('[data-f-error]' + vis) ? 'error' : 'known');
      });
    }).catch(function (why) {
      if (answered) return done(f, 'ok');
      // the visitor closed the puzzle: leave the form as it is, a tap on the button tries again
      if (/closed|cancel/i.test(String(why))) return f.removeAttribute('aria-busy');
      plain(f);
    });
  }, true);
  // back from a plain post: Liquid already shows ok or error; the page hears it once per return (not on a reload)
  var nav = (w.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  var posted = nav.type !== 'reload' && d.referrer.indexOf(location.origin + '/') === 0 && (q.get('customer_posted') || q.get('contact_posted')) === 'true';
  if (posted) {
    var hf = location.hash && d.getElementById(location.hash.slice(1));
    var f0 = hf && hf.matches && hf.matches(SEL) ? hf : d.querySelector(SEL);
    if (f0) setTimeout(function () { done(f0, f0.querySelector('[data-f-error]:not([hidden])') ? 'error' : 'ok'); }, 0);
  }
  // previews: ?form=ok|known|error shows that state, to look at it
  if (!C.draft && q.get('form') && !(F.live && F.live())) [].forEach.call(d.querySelectorAll(SEL), function (f) { state(f, q.get('form')); });
  // a mistyped address (gmial.com, hotmail.con): the fix offered under the field, one tap to take it (Theme settings >
  // Email signup; a page's own form gets it too). Only what is almost surely a slip: a mistyped .com/.net ending, or a
  // near miss of a big mailbox provider's name (never a short one: me.com, mac.com, aol.com are real, and so are
  // company domains); a provider's own country ending (hotmail.ca, outlook.de) is left alone.
  var PROV = ['gmail', 'yahoo', 'hotmail', 'outlook', 'icloud', 'comcast', 'sbcglobal', 'verizon', 'ymail', 'protonmail', 'googlemail', 'bellsouth'];
  var REAL = /^(mail|email|gmx|zoho|fastmail|hey|tutanota|yandex|qq|naver|live|msn|me|mac|aol|att|cox|earthlink|juno|optonline|frontier|windstream|rocketmail)\./;
  function dist(a, b) {
    var m = a.length, n = b.length, r = [], i, j;
    if (Math.abs(m - n) > 2) return 3;
    for (i = 0; i <= m; i++) r[i] = [i];
    for (j = 1; j <= n; j++) r[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) {
      r[i][j] = Math.min(r[i - 1][j] + 1, r[i][j - 1] + 1, r[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) r[i][j] = Math.min(r[i][j], r[i - 2][j - 2] + 1);
    }
    return r[m][n];
  }
  function fix(v) {
    var at = v.lastIndexOf('@');
    if (at < 1) return '';
    var dom = v.slice(at + 1).toLowerCase(), dot = dom.indexOf('.');
    if (dot < 1 || REAL.test(dom)) return '';
    var label = dom.slice(0, dot), tld = dom.slice(dot + 1);
    // a slip in the ending: that alone is fixed, the name stays
    var t2 = tld.replace(/^(con|cmo|cm|comm|ocm|vom|xom|om|c0m|co\.m)$/, 'com').replace(/^(ney|nte|nt|met)$/, 'net');
    if (t2 !== tld) return v.slice(0, at + 1) + label + '.' + t2;
    if (PROV.indexOf(label) >= 0 || label.length < 4) return '';
    for (var k = 0; k < PROV.length; k++) {
      var p = PROV[k];
      if (label[0] !== p[0] || dist(label, p) !== 1) continue;
      return v.slice(0, at + 1) + p + '.' + (/^(com|con|co|cm)$/.test(tld) ? 'com' : tld);
    }
    return '';
  }
  if (C.es !== false) d.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.type !== 'email' || !el.form) return;
    // the hint goes under the field's row, never between a field and its button
    var box = el.closest('.fu-row,.fu-grid') || el.closest('.fu-field') || el;
    var h = el.form.querySelector('[data-f-hint="' + el.id + '"]'), s = fix(String(el.value || '').trim());
    if (!s) { if (h) h.remove(); return; }
    if (!h) {
      h = d.createElement('p'); h.className = 'fu-hint'; h.setAttribute('data-f-hint', el.id); h.setAttribute('aria-live', 'polite');
      box.parentNode.insertBefore(h, box.nextSibling);
    }
    h.textContent = '';
    var b = d.createElement('button'); b.type = 'button'; b.textContent = s;
    b.addEventListener('click', function () { el.value = s; h.remove(); el.focus(); });
    var tx = String((C.t && C.t.suggest) || 'Did you mean %s?').split('%s');
    h.appendChild(d.createTextNode(tx[0] || ''));
    h.appendChild(b);
    h.appendChild(d.createTextNode(tx.length > 1 ? tx[1] : '?'));
  });

  // the header of the theme's pages set to "when scrolling up": out of the way going down, back after scrolling up a
  // little (the distance adds up over slow frames)
  var hd = d.querySelector('.fu-head[data-sticky=up]');
  if (hd) {
    // the section around the bar and the header is what moves (base.css): its height, the bar's included
    var hs = hd.closest('.shopify-section') || hd;
    var last = w.scrollY, turn = w.scrollY, tick = false, down = true;
    w.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      w.requestAnimationFrame(function () {
        var y = w.scrollY, dn = y > last;
        if (dn !== down) { down = dn; turn = last; }
        if (y <= hs.offsetHeight) hd.removeAttribute('data-away');
        else if (down && y - turn > 8 && y > hs.offsetHeight * 2) hd.setAttribute('data-away', '');
        else if (!down && turn - y > 24) hd.removeAttribute('data-away');
        last = y; tick = false;
      });
    }, { passive: true });
  }

  // the signup popup (data-f-piece="signup-popup"): once per visit, after its delay or scroll depth, whichever first;
  // never when the visitor moves to leave, never while they type in a form, never over Shopify's cookie banner or its
  // preferences or another dialog, never after a signup
  var pop = d.querySelector('dialog[data-f-popup]');
  if (pop && pop.showModal && !C.design) {
    var KEY = 'fu_popup', seen = false, timer = null;
    // "seen this visit" is stored on the device only once storing is allowed (TKG 165 (3)); before that it holds for
    // this page view only
    var mayStore = function () { return !!(F.consent && F.consent.allowed && F.consent.allowed()); };
    var remember = function () { seen = true; if (mayStore()) { try { sessionStorage.setItem(KEY, '1'); } catch (x) {} } };
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (x) {}
    d.addEventListener('funnel:signup', function (e) { if (e.detail && e.detail.state !== 'error') remember(); });
    var busy = function () {
      var a = d.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !pop.contains(a)) return true;
      return [].some.call(d.querySelectorAll('[id^="shopify-pc__"]'), function (el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden'; });
    };
    var onScroll;
    var open = function () {
      if (seen || pop.open || d.querySelector('dialog[open]')) return;
      if (busy()) { clearTimeout(timer); timer = setTimeout(open, 4000); return; }
      remember();
      w.removeEventListener('scroll', onScroll);
      try { pop.showModal(); } catch (x) { return; }
      // the dialog itself takes the focus (a screen reader reads its title): not the close button, whose ring would
      // show to a visitor who never pressed a key, nor the email field, whose keyboard would cover the popup on a phone
      try { pop.focus({ preventScroll: true }); } catch (x) {}
      try { pop.dispatchEvent(new CustomEvent('funnel:popup', { bubbles: true, detail: { state: 'open' } })); } catch (x) {}
    };
    var depth = Math.max(0, Math.min(95, parseFloat(pop.getAttribute('data-scroll')) || 50)) / 100;
    onScroll = function () {
      var h = d.documentElement.scrollHeight - w.innerHeight;
      if (h > 0 && w.scrollY / h >= depth) open();
    };
    if (q.get('popup') === 'now' && !(F.live && F.live())) { seen = false; setTimeout(open, 300); }
    else if (!seen) {
      timer = setTimeout(open, Math.max(5, parseFloat(pop.getAttribute('data-delay')) || 25) * 1000);
      w.addEventListener('scroll', onScroll, { passive: true });
    }
    // a tap on the dimmed page outside it closes it (a tap on its own padding does not)
    pop.addEventListener('click', function (e) {
      if (e.target !== pop) return;
      var r = pop.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) pop.close();
    });
    pop.addEventListener('close', function () {
      try { pop.dispatchEvent(new CustomEvent('funnel:popup', { bubbles: true, detail: { state: 'closed' } })); } catch (x) {}
    });
  }
})();
